import React from 'react';

export default function Footer() {
  return (
    <footer
      id="footer"
      className="relative border-t border-ink-100 bg-grad-footer"
    >
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-8 items-start">
          {/* Branding */}
          <div>
            <div className="flex items-center gap-2">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-grad-brand-accent text-white font-bold text-sm shadow-sm">
                B
              </span>
              <span className="font-semibold text-ink-900">BD-VAX</span>
            </div>
            <p className="mt-3 text-sm text-ink-500 leading-relaxed">
              Purifying generative LLMs from backdoors &mdash; without prior
              trigger knowledge or a clean reference model.
            </p>
            <p className="mt-3 text-xs text-ink-400">
              ICLR 2026 &middot; Kim Lab, NC State
            </p>
          </div>

          {/* Resources */}
          <div>
            <div className="text-xs font-semibold uppercase tracking-widest text-ink-500">
              Resources
            </div>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <a
                  href="https://openreview.net/forum?id=M7eWB695jp"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-ink-700 hover:text-brand-700 transition-colors"
                >
                  → OpenReview
                </a>
              </li>
              <li>
                <a
                  href="https://arxiv.org/abs/2603.13461"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-ink-700 hover:text-brand-700 transition-colors"
                >
                  → arXiv
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/JEKimLab/bd-vax"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-ink-700 hover:text-brand-700 transition-colors"
                >
                  → Code on GitHub
                </a>
              </li>
              <li>
                <a
                  href="https://iclr.cc/virtual/2026/poster/10009970"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-ink-700 hover:text-brand-700 transition-colors"
                >
                  → ICLR poster page
                </a>
              </li>
            </ul>
          </div>

          {/* Authors / Contact */}
          <div>
            <div className="text-xs font-semibold uppercase tracking-widest text-ink-500">
              Authors
            </div>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <a
                  href="https://jianwei.gallery/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-ink-700 hover:text-brand-700 transition-colors"
                >
                  Jianwei Li
                </a>
              </li>
              <li>
                <a
                  href="https://jekimlab.github.io/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-ink-700 hover:text-brand-700 transition-colors"
                >
                  Jung-Eun Kim
                </a>
              </li>
              <li>
                <a
                  href="mailto:jli265@ncsu.edu"
                  className="text-ink-700 hover:text-brand-700 transition-colors"
                >
                  jli265@ncsu.edu
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-ink-100 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-xs text-ink-500">
            © {new Date().getFullYear()} Kim Lab, NC State University. All
            rights reserved.
          </p>
          <p className="text-xs text-ink-400">
            Built with React &amp; Tailwind CSS.
          </p>
        </div>
      </div>
    </footer>
  );
}
